export default "__VITE_ASSET__DaDu$kmt__"